import { useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Image from "next/image";
import React from "react";

import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import { NewPostPageButton } from "@/features/post/components/NewPostPageButton";
import { AvatarWithFallback } from "@/features/user/components/avatar/AvatarWithFallBack";
import { FeatureNameEnum } from "@/generated/generated-hooks";

const SiteTopNavigationUserCredentialPlaceholder = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { isEnabled } = useFeatureEnabled();
  const isDirectMessageEnabled = isEnabled(FeatureNameEnum.DirectMessage);

  return (
    <>
      <NewPostPageButton disabled={true} />

      {isDirectMessageEnabled && (
        <div className="ml-6">
          <Image
            alt="message icon"
            src="/assets/siteTopNavigation/button/message.png"
            layout="fixed"
            width={22}
            height={22}
          />
        </div>
      )}

      <div className="flex ml-6 h-full items-center">
        {isMdUp && (
          <Image
            alt="notification icon"
            layout="fixed"
            width={19}
            height={25}
            src="/assets/siteTopNavigation/notification/bell.png"
          />
        )}
      </div>

      <div className="ml-5">
        <Button
          aria-controls="avatar-menu"
          aria-haspopup="true"
          endIcon={<ArrowDropDownIcon />}
          disabled={true}
          variant="text"
        >
          <AvatarWithFallback
            accountName={null}
            displayName={null}
            sizeClassName="avatar-36"
            avatarUrl={null}
          />
        </Button>
      </div>
    </>
  );
};

export default SiteTopNavigationUserCredentialPlaceholder;
